import { DateTimePicker, LocalizationProvider, PickersActionBar, PickersDay } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import styles from '@styles/components/DatePicker.module.css';
import es from 'date-fns/locale/es';
import * as React from 'react';

const weekDays = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'];

const formatDayOfWeek = (day) => {
    if (day instanceof Date && !Number.isNaN(day.getTime())) {
        return weekDays[day.getDay()];
    }

    return '';
};

const CustomDay = (props) => (
    <PickersDay
      {...props}
      style={props.selected ? {backgroundColor: '#EC6C56'} : null}
      sx={{
        color: '#000',
        fontWeight: 700,
        '&:hover': {
          backgroundColor: props.selected ? '#EC6C56' : '#f2f2f2',
        },
        '&:focus': {
            backgroundColor: props.selected ? '#EC6C56' : '#f2f2f2',
          },
        '& .MuiTypography-root': {
            color: '#000',
            fontWeight: 700
        },
      }}
    />
  );

const CustomActionBar = (props) => {
    <PickersActionBar
    {...props}
    style={{      color: '#000',
    fontWeight: 700,}}
    sx={{
      color: '#000',
      fontWeight: 700,
    }}
    >
    </PickersActionBar>
}

const sxDatePicker = {
    width: '90%',
    '& .css-1vooibu-MuiSvgIcon-root': {
        fill: '#EC6C56'
    },
    '& .MuiInputLabel-root.Mui-focused': { color: '#EC6C56' },
    '& .MuiOutlinedInput-root': { borderColor: '#EC6C56' },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#EC6C56',
    },
}

const slotPropsPicker = {
    calendarHeader: {sx: {                
            '& .css-1vooibu-MuiSvgIcon-root': {
                fill: '#EC6C56'
            },
        }
    },
}

const defaultValues = [new Date(), new Date()]

const DateRangePicker = ({updateDateRange, initValues = defaultValues, style = {}}) => {
    const customEsLocale = {
        ...es,
        localize: {
            ...es.localize,
            month: (month, { width }) => {
            const monthName = es.localize.month(month, { width });
            return monthName.charAt(0).toUpperCase() + monthName.slice(1);
            },
        },
    };

  const [value1, setValue1] = React.useState(initValues ? initValues[0] : defaultValues[0])
  const [value2, setValue2] = React.useState(initValues ? initValues[1] : defaultValues[1])

  const disolveChange = (e) => {
    setValue1(null)
    setValue2(null)
    updateDateRange(null, null)
  }

  return (
    <div style={Object.assign({width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}, style)}>
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customEsLocale}>
        <p className={styles['text']}>
            Desde ...
        </p>
        <DateTimePicker views={['year', 'month', 'day']}
        closeOnSelect
        disableFuture
        value={value1} onChange={(newValue) => setValue1(newValue)}
        dayOfWeekFormatter={formatDayOfWeek}
        format="yyyy/MM/dd"
        label='Fecha de inico . . .'
        sx={sxDatePicker}
        slots={{day: CustomDay, actionBar: CustomActionBar}}
        slotProps={slotPropsPicker}
        />
        <div style={{width: '100%', height: '10%'}}/>
        <p className={styles['text']}>
            Hasta ...
        </p>
        <DateTimePicker views={['year', 'month', 'day']}
        closeOnSelect
        disableFuture
        value={value2} onChange={(newValue) => setValue2(newValue)}
        dayOfWeekFormatter={formatDayOfWeek}
        format="yyyy/MM/dd"
        label='Fecha de finalizacion . . .'
        sx={sxDatePicker}
        slots={{day: CustomDay, actionBar: CustomActionBar}}
        slotProps={slotPropsPicker}
        />
    </LocalizationProvider>
    <div style={{width: '100%', height: '50px', marginBottom: '-5%', marginTop:'5%',display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
            <div style={{backgroundColor: '#F4F4F4', color: '#666'}} onClick={disolveChange} className={styles['button']}>Quitar</div>
            <div style={{width: '15px'}}/>
            <div style={{backgroundColor: '#EC6C56', color: '#FFF'}} onClick={() => updateDateRange(value1, value2)} className={styles['button']}>Aplicar</div>
        </div>
    </div>
  );
}

export default DateRangePicker
